<template>
    <div id="app" class="app-general">
        <router-view />
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'App',
}
</script>

<style>
@import '../../assets/scss/fonts.scss';
/* @import "assets/scss/global-styles.scss"; */

.app-general {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue